async function geocodingReverse(func, endpoint, params) {

    let coords = params.geom.getCoordinates();
    let backendParams = {
        'lang' : params.lang,
        'api-key': params['api-key'],
        'request-crs': params['request-crs'],
        'crs': params.crs,
        'boundary.circle.radius': params.radius,
        'size': params.size,
        'point.lon': coords[0],
        'point.lat': coords[1],
        'text': params.text,
        'sources': params.sources
    },
    backendNonNullParams = Object.fromEntries(Object.entries(backendParams).filter(([_, v]) => v != null)), 
    backendSearch = new URLSearchParams(backendNonNullParams);

    let url = `${endpoint}/reverse?${backendSearch}`;
    console.log(params.geom,coords,endpoint,url);


    //'lang' lang=fin
    //'api-key' &api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2
    //&&&request-crs=http://www.opengis.net/def/crs/EPSG/0/3067
    // &crs=http://www.opengis.net/def/crs/EPSG/0/3067&size=50
    // &boundary.circle.radius=500
    // &point.lon=384760&point.lat=6676308
    // &text=pasilalang=fin&api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2

    return fetch(url).then(r=>r.json()).then(func);
}

async function geocodingSearch(func, endpoint, params){

    let backendParams = {
        'lang' : params.lang,
        'api-key': params['api-key'],
        'request-crs': params['request-crs'],
        'crs': params.crs,
        'size': params.size,
        'text': params.text,
        'sources': params.sources
    },
    backendNonNullParams = Object.fromEntries(Object.entries(backendParams).filter(([_, v]) => v != null)), 
    backendSearch = new URLSearchParams(backendNonNullParams);

    let url = `${endpoint}/search?${backendSearch}`;
    console.log(params.text,endpoint,url);
    return fetch(url).then(r=>r.json()).then(func);
    
}

async function geocodingSimilar(func, endpoint, params){

    let backendParams = {
        'lang' : params.lang,
        'api-key': params['api-key'],
        'request-crs': params['request-crs'],
        'crs': params.crs,
        'size': params.size,
        'text': params.text,
        'sources': params.sources
    },
    backendNonNullParams = Object.fromEntries(Object.entries(backendParams).filter(([_, v]) => v != null)), 
    backendSearch = new URLSearchParams(backendNonNullParams);

    let url = `${endpoint}/similar?${backendSearch}`;
    console.log(params.text,endpoint,url);
    return fetch(url).then(r=>r.json()).then(func);
    
}
export {
    geocodingReverse,
    geocodingSearch,
geocodingSimilar }